import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import translations from '../../../../../../ui/traslation/traslationAdministracion.json'
import clsx from 'clsx'
import { Text } from '../../../../../../ui'
import SearchIcon from '@mui/icons-material/Search'
import { formatCurrency} from '../../../../../../../utils/formatter'
import DoneAllIcon from '@mui/icons-material/DoneAll'
import { getStatusBadgeClass, getStatusLabel } from './statusBadge'

const TableDesconciliar = ({ rows, filasSeleccionadas, onSeleccionar, tipoMovimiento }) => {
  //const [page] = useState(0)
  const styles = {
    table: 'w-full table-auto text-[0.725rem] border-collapse leading-tight bg-white',
    thead: 'sticky top-0 z-10 bg-white',
    th: 'py-2 px-1 w-auto max-w-[120px] text-center break-words border-b border-gray-200',
    tr: 'border-b border-gray-200 hover:bg-gray-100/50',
    td: 'py-1 px-2 w-auto  max-w-[200px] text-center break-words align-top',
    smallCol: 'w-auto max-w-[80px]',
    wideCol: 'w-auto max-w-[300px]',
    boldText: 'font-bold text-[0.65rem]',
    text: 'text-[0.705rem] text-gray-500'
  }
  const orderableCols = [
    { col: '', field: null },
    { col: 'Comprobante', field: 'comprobante' },
    { col: 'Cliente', field: 'razonSocial' },
    { col: 'Fecha', field: 'fecha' },
    { col: 'Clasificación', field: 'nombreCuenta' },
    { col: 'Monto', field: 'montoTotal' },
    { col: 'Status', field: 'status' },
    { col: 'Acciones', field: 'aprobado' }
  ]

  if (!rows || rows.length === 0) {
    return (
      <div className='flex flex-col items-center py-12'>
        <SearchIcon fontSize='large' className='mb-4 text-gray-400' />
        <Text>{translations.tableAction.noData}</Text>
      </div>
    )
  } else
    return (
      <div className='overflow-x-auto'>
        <div className='h-full mt-2'>
          <table className={styles.table}>
            <thead className={styles.thead}>
              <tr>
                {orderableCols.map(({ col, field }, i) => (
                  <th
                    key={i}
                    className={clsx(
                      styles.th,
                      { 'cursor-pointer': field },
                      i === 0 && styles.smallCol
                    )}
                    onClick={() => field}
                  >
                    {col}
                    <KeyboardArrowDownIcon className={clsx('transition-all ml-2 cursor-pointer')} />
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) =>
                row.auxiliar
                  ?.filter(aux => {
                    if (!tipoMovimiento) return true;
                    return aux.tipoMovimiento === tipoMovimiento;
                  })
                  ?.map((aux, j) => {
                  const estaSeleccionado = filasSeleccionadas.includes(
                    Number(aux.id ?? aux.idPrincipal)
                  )

                  return (
                    <tr key={`${i}-${j}`} className={clsx(styles.tr)}>
                      <td className={clsx(styles.td, styles.smallCol)}></td>
                      <td className={styles.td}>
                        <Text className={styles.boldText}>{aux.comprobante}</Text>
                      </td>
                      <td className={styles.td}>
                        <Text className={styles.boldText}>{aux.nombreCuentaBanco}</Text>
                      </td>

                      {/* Fecha */}
                      <td className={styles.td}>
                        <Text className={styles.boldText}>
                          {new Date(aux.fecha).toLocaleDateString()}
                        </Text>
                      </td>

                      {/* Clasificación */}
                      <td className={styles.td}>
                        <Text className={styles.boldText}>{aux.descripcion}</Text>
                      </td>

                      {/* Monto */}
                      <td className={styles.td}>
                        <Text className={styles.boldText}>
                          {formatCurrency(aux.montoCargo || aux.montoAbono)}
                        </Text>
                      </td>

                      {/* Status */}
                      <td className={styles.td}>
                        <Text className={getStatusBadgeClass(aux.status)}>
                          {getStatusLabel(aux.status)}
                        </Text>
                      </td>

                      {/* Botón seleccionar */}
                      <td className={styles.td}>
                        <div className='flex h-full items-center justify-center space-x-3'>
                          <div
                            className='flex flex-col text-xs text-gray-500 items-center justify-center hover:cursor-pointer'
                            onClick={() => onSeleccionar?.(aux)}
                          >
                            <button
                              className={clsx(
                                'flex items-center justify-center w-7 h-7 rounded-full shadow-full-xs transition-colors duration-150',
                                {
                                  'bg-accent2 text-white hover:bg-accent2/90 cursor-pointer':
                                    estaSeleccionado,
                                  'bg-gray-100 text-gray-300 hover:bg-gray-200 cursor-pointer':
                                    !estaSeleccionado
                                }
                              )}
                            >
                              <DoneAllIcon className='w-4 h-4' />
                            </button>
                            <Text className='mt-2'>
                              {estaSeleccionado ? 'Seleccionado' : 'Seleccionar'}
                            </Text>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default TableDesconciliar
